import { render, staticRenderFns } from "./NoPerm.vue?vue&type=template&id=7972bc32&"
import script from "./NoPerm.vue?vue&type=script&lang=js&"
export * from "./NoPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports